import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_sp_monetization_female_fasting~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_sp_monetization_female_fasting__b'
					),
			},
		},
	},
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_sp_monetization_female_fasting~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_sp_monetization_female_fasting__c'
					),
			},
		},
	},
]

export default config
